module.exports = __webpack_public_path__ + "img/jinrishouyi_icon.dcff4a49.png";